var React = require('react');

function WindowsInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.5001 12.4229H10.8751V20.8135L22.5001 22.501V12.4229Z","key":0}),React.createElement("path",{"d":"M10.125 12.4229H1.5V19.4541L10.125 20.7057V12.4229Z","key":1}),React.createElement("path",{"d":"M22.5001 1.49902L10.8751 3.1584V11.6709H22.5001V1.49902Z","key":2}),React.createElement("path",{"d":"M10.125 3.26697L1.5 4.49978V11.6716H10.125V3.26697Z","key":3})]);
}

WindowsInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WindowsInline;

WindowsInline.default = WindowsInline;
